import { Component, OnInit, Input } from '@angular/core';
import { JsonInput } from '@ptl/global-components';
import { UntypedFormControl } from '@angular/forms';

interface MediaCard {
  cardThumbnail;
  imgAltText: string;
  cardTitle: string;
  cardDescription: string;
  redirectLink: string;
  articleTags: [];
  dateAdded: Date;
}

@Component({
  selector: 'app-media-list',
  templateUrl: './media-list.component.html',
  styleUrls: ['./media-list.component.scss'],
  standalone: false
})
export class MediaListComponent implements OnInit{

  @Input() @JsonInput() mediaCardArray: MediaCard[] = [];
  filteredCardArray = [];
  dropdownFormControl = new UntypedFormControl();
  searchFormControl = new UntypedFormControl();
  lobFilterValues = [
    "Individual",
    "Large Group",
    "Small Group",
    "Medicare Supplement",
    "General"
  ];

  ngOnInit(){
    this.filteredCardArray = [...this.mediaCardArray];
    this.formatArticleTags()
  }

  filterItems(){
    this.filteredCardArray = [...this.mediaCardArray]

    if(this.searchFormControl.value){
      this.searchFilterChanged();
    }
    if(this.dropdownFormControl.value[0]){
      this.dropdownFilterChanged();
    }
  }


  searchFilterChanged(){
    const searchValueLower = this.searchFormControl.value.toLowerCase();
    let cardTitleLower = '';
    this.filteredCardArray = this.filteredCardArray.filter(item =>{
      cardTitleLower = (item.cardTitle || '').toLowerCase();
      return cardTitleLower.includes(searchValueLower);
    });
  }
  
  dropdownFilterChanged(){
    this.filteredCardArray = this.filteredCardArray.filter(card => {
      return card.articleTags.some(tag => this.dropdownFormControl.value.includes(tag))
    }); 
  }
  
  formatArticleTags(){
    this.filteredCardArray.forEach(card =>{
      console.log(card);
      card.articleTags = card.articleTags ? card.articleTags : ["General"];
      card.articleTags.forEach(tag =>{
        const replacementIndex = card.articleTags.indexOf(tag);
        const splitTag = tag.split(":")[1];
        const tagTitle = splitTag.split("/")[1];
        console.log(tagTitle)
        card.articleTags[replacementIndex] = this.toTitleCase(tagTitle.split("-").join(" ")); 
      });
      console.log(card.articleTags);
    });

    
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
  }

  //TODO: create paginator compatible with media card array

}
